import Percentile from './Percentile';
export default Percentile;